import { useEffect, useState } from "react";
import { Play, PenLine, Megaphone } from "lucide-react";
import { API } from "@/lib/api";
import Reveal from "@/components/Reveal";

const STUDIO_IMG =
  "https://images.unsplash.com/photo-1559523161-0fc0d8b38a7a?crop=entropy&cs=srgb&fm=jpg&q=85";

const Stat = ({ value, label }) => (
  <div className="rounded-2xl border border-edge bg-ink2 p-6 text-center" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <p className="font-mono-score text-4xl font-bold text-crimson">{value}</p>
    <p className="mt-2 font-display text-base font-bold uppercase tracking-wider text-slate-300">{label}</p>
  </div>
);

const Sobre = () => {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    API.get("/articles", { params: { limit: 100 } }).then(({ data }) => setArticles(data));
  }, []);
  const nArt = articles.filter((a) => a.category === "articulo").length;
  const nCron = articles.filter((a) => a.category === "cronica").length;

  return (
    <div className="bg-ink pt-32">
      <div className="mx-auto max-w-7xl px-5 pb-24 md:px-12">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal>
            <p className="eyebrow mb-3">Quién hay detrás</p>
            <h1 className="font-display text-4xl font-black uppercase leading-[0.98] tracking-tight text-white sm:text-6xl">
              Hola, soy <span className="text-crimson text-glow-red">ENOL</span>,<br />
              la voz rojiblanca de TikTok
            </h1>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-slate-300 sm:text-lg">
              <p>
                ENOLFC nace en TikTok, pero se forja en El Molinón. Soy sportinguista de cuna
                y desde mi cuenta cuento lo que siento en cada partido: reacciones en directo,
                análisis sin edulcorar y mucho humor rojiblanco.
              </p>
              <p>
                Esta web es el siguiente paso: aquí se quedan las crónicas y los artículos que
                en un vídeo no caben. Todo lo que el Sporting y el fútbol me hacen sentir,
                escrito con el corazón y sin filtros.
              </p>
            </div>
            <a
              href="https://www.tiktok.com/@enolfc"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sobre-tiktok-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 font-display text-lg font-bold uppercase tracking-wider text-ink transition-transform hover:scale-105"
            >
              <Play className="h-4 w-4 fill-current" /> Sígueme en @ENOLFC
            </a>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-crimson/20 blur-3xl" />
              <img
                src={STUDIO_IMG}
                alt="Estudio de ENOLFC"
                className="relative aspect-[4/3] w-full rounded-3xl border border-white/10 object-cover"
              />
              <div className="glass absolute -bottom-6 -left-6 hidden rounded-2xl p-5 sm:block">
                <p className="flex items-center gap-2 font-display text-lg font-bold uppercase text-white">
                  <Megaphone className="h-4 w-4 text-crimson" /> Desde la grada
                </p>
                <p className="mt-1 font-mono-score text-[11px] uppercase tracking-widest text-slate-400">
                  El Molinón · Gijón
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-20 grid gap-5 sm:grid-cols-3">
          <Reveal><Stat value={nArt} label="Artículos publicados" /></Reveal>
          <Reveal delay={0.1}><Stat value={nCron} label="Crónicas firmadas" /></Reveal>
          <Reveal delay={0.2}><Stat value="100%" label="Pasión rojiblanca" /></Reveal>
        </div>

        <Reveal>
          <div className="glass mt-16 rounded-3xl p-8 md:p-12">
            <p className="flex items-center gap-3 font-display text-2xl font-extrabold uppercase text-white sm:text-3xl">
              <PenLine className="h-6 w-6 text-crimson" /> Manifiesto ENOLFC
            </p>
            <div className="mt-5 grid gap-4 text-slate-300 md:grid-cols-3">
              <p>Contar el fútbol como se vive en la grada, no desde la sala de prensa.</p>
              <p>Defender al Sporting con argumentos y a la afición con respeto.</p>
              <p>Nada de titulares vacíos: cada crónica se firma con el corazón.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default Sobre;
